import { LIST_TYPE } from '../constant'

const defaultState = {
  items: [],
  count: 0,
  page: 0,
  sort: '',
  totalPages: 0,
  collection: null,
}


export default function list(state = defaultState, action) {
  switch (action.type) {
    case 'GET_LIST_SUCCESS': return {
      ...state,
      page: action.data.page,
      items: action.data.hits,
      sort: action.sort || '',
      count: action.data.nbHits,
      collection: action.collection,
      totalPages: action.data.nbPages,
    }

    case 'GET_LIST_ERROR': return {
      ...state,
      items: [],
      collection: null,
    }


    case 'DECLINE_PERMISSION':
    case 'VALIDATE_PERMISSION': return {
      ...state,
      items: state.collection === LIST_TYPE.WAITINGLIST ? state.items.filter(d => d.objectID !== action.userId) : state.items,
    }

    default: return state
  }
}
